import * as z from "zod";

/** The team's Gale record has no Clerk organization id; pages explain it. */
export const HSA_GALE_ORGANIZATION_NOT_LINKED =
  "HSA_GALE_ORGANIZATION_NOT_LINKED";

export const hsaReconciliationDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

/** Gale's own limit: it answers a larger `per_page` with a validation error
 * (`GEN_003`, "must not be greater than 100"). */
export const HSA_RECONCILIATION_MAX_PAGE_SIZE = 100;

/** 1-based page, mirroring how Gale counts. */
export const hsaReconciliationPageInputSchema = z.object({
  page: z.number().int().min(1),
  perPage: z.number().int().min(1).max(HSA_RECONCILIATION_MAX_PAGE_SIZE),
  dateFrom: hsaReconciliationDateSchema.optional(),
  dateTo: hsaReconciliationDateSchema.optional(),
});

export const hsaReconciliationPaginationSchema = z.object({
  currentPage: z.number().int(),
  perPage: z.number().int(),
  total: z.number().int(),
  totalPages: z.number().int(),
});

/** A CSV for the browser to save, from Gale or built by Redo. `truncated`
 * means the file was capped (Gale ends it in a TRUNCATED marker row) and the
 * merchant must be told. */
export const hsaReconciliationCsvOutputSchema = z.object({
  fileName: z.string(),
  csv: z.string(),
  truncated: z.boolean(),
});
